import { Pipe, PipeTransform, inject } from '@angular/core';
import { WithTranslations } from '@wilson/interfaces';
import { EntityLangType } from '@wilson/localization';
import { TransformMasterDataTranslationService } from './transform-masterdata-translation.service';

/**
 * Maps each row to `translatedName` using the given `entityLang` key (`nameDe`, …).
 * Optional `sort` orders by `translatedName`. Pass `entityLang` from your component
 * (e.g. `LocalizationState.getEntityLang` via a signal) so the template updates when language changes.
 * This pipe is pure for performance reasons, which is why it does not read from the store directly.
 */
@Pipe({
  name: 'transformMasterdataTranslation',
  standalone: true,
  pure: true,
})
export class TransformMasterdataTranslationPipe implements PipeTransform {
  private transformService = inject(TransformMasterDataTranslationService);

  transform<T extends Partial<WithTranslations>>(
    value: T[] | null,
    {
      entityLang,
      sort = null,
    }: {
      entityLang: EntityLangType;
      sort?: 'asc' | 'desc' | null;
    },
  ): (T & { translatedName: string })[] {
    if (!value || !Array.isArray(value)) {
      return [];
    }
    const transformed = this.transformService.transform(value, entityLang);
    if (sort !== null) {
      return transformed.sort((a, b) => {
        return sort === 'asc'
          ? a.translatedName.localeCompare(b.translatedName)
          : b.translatedName.localeCompare(a.translatedName);
      });
    }
    return transformed;
  }
}
